import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function AggregatorLookupKeywords({ aggregatorLookupKeywords, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Lookup keywords:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="lookupKeywords"
          id="lookupKeywords"
          placeholder="Keywords"
          value={aggregatorLookupKeywords || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(AggregatorLookupKeywords);
